import { render, staticRenderFns } from "./FormImageInput.vue?vue&type=template&id=989e889c"
import script from "./FormImageInput.vue?vue&type=script&lang=js"
export * from "./FormImageInput.vue?vue&type=script&lang=js"
import style0 from "./FormImageInput.vue?vue&type=style&index=0&id=989e889c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports